import { render, staticRenderFns } from "./UpdateReward.vue?vue&type=template&id=19822076"
import script from "./UpdateReward.vue?vue&type=script&lang=js"
export * from "./UpdateReward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports